/**
 * ChatHomePageSwitch — the "Chat | Files" bar under a single-column chat home.
 *
 * Shared by the phone (MobileChatScreen, < 768px) and the narrow desktop chat
 * home (ChatHomeView, 768–949px), where the right column's content — shortcuts,
 * or the file opened from them — becomes a second page. It stays on screen
 * while a file is open, so the chat is always one click away.
 *
 * The editor toolbar's ModeToggle pill, so it reads like the Preview | Source
 * switch rather than a new control.
 */
import { LayoutGrid, MessageSquare } from 'lucide-react'
import { ModeToggle, type ModeOption } from '@papan/collab/ui'

export type ChatHomePage = 'chat' | 'files'

const OPTIONS: ModeOption<ChatHomePage>[] = [
  { value: 'chat', label: 'Chat', icon: <MessageSquare size={14} /> },
  { value: 'files', label: 'Files', icon: <LayoutGrid size={14} /> },
]

export function ChatHomePageSwitch({ page, onChange }: {
  page: ChatHomePage
  onChange: (page: ChatHomePage) => void
}) {
  return (
    <div className="shrink-0 flex justify-center pt-2 pb-3" data-testid="chat-home-page-switch">
      <ModeToggle options={OPTIONS} value={page} onChange={onChange} />
    </div>
  )
}
